<template>
  <span
    v-if="hasSession"
    class="badge badge-light-info fw-bolder cursor-pointer"
    role="button"
    title="Ver sessões da recorrência"
    @click.stop="$emit('open')"
  >
    Sessão nº {{ session }}/{{ total }}
  </span>
</template>

<script>
export default {
  name: 'ScheduleRecurrenceBadge',
  props: {
    session: { type: [Number, String], default: null },
    total: { type: [Number, String], default: null },
  },
  emits: ['open'],
  computed: {
    hasSession() {
      return this.session != null && this.total != null && Number(this.total) > 0;
    },
  },
};
</script>
